import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export abstract class TranslateLoader {
  abstract getTranslation(lang: string): Observable<any>;
}

@Injectable()
export class TranslateFakeLoader extends TranslateLoader {
  getTranslation(_lang: string): Observable<any> {
    return of({});
  }
}
